import { Button, ToggleButtonGroup } from '@healthinal/ui';
import { CreateQuantiferonTestDtoInterpretation } from '../../../api/generated/model';
import { getLabOrderResultInterpretationName } from '../../../utils/labOrder.ts';

interface Props {
  value: CreateQuantiferonTestDtoInterpretation | null;
  onChange: (resultInterpretation: CreateQuantiferonTestDtoInterpretation | null) => void;
  resultOptions: CreateQuantiferonTestDtoInterpretation[];
}
export function ResultInterpretationButtonGroup({ value, onChange, resultOptions }: Props) {
  return (
    <ToggleButtonGroup value={value} spacing={1}>
      {Object.values(CreateQuantiferonTestDtoInterpretation)
        .filter((option) => resultOptions.includes(option))
        .map((option) => (
          <Button value={option} key={option} onClick={() => onChange(option)}>
            {getLabOrderResultInterpretationName(option)}
          </Button>
        ))}
    </ToggleButtonGroup>
  );
}
